import React, { createContext, useContext, useState, useCallback } from 'react'

interface CalendarAuthContextType {
  isGoogleAuthLoading: boolean
  isAppleAuthLoading: boolean
  isOutlookAuthLoading: boolean
  setGoogleAuthLoading: (loading: boolean) => void
  setAppleAuthLoading: (loading: boolean) => void
  setOutlookAuthLoading: (loading: boolean) => void
  isAnyAuthLoading: boolean
}

const CalendarAuthContext = createContext<CalendarAuthContextType | undefined>(
  undefined
)

export function CalendarAuthProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const [isGoogleAuthLoading, setIsGoogleAuthLoading] = useState(false)
  const [isAppleAuthLoading, setIsAppleAuthLoading] = useState(false)
  const [isOutlookAuthLoading, setIsOutlookAuthLoading] = useState(false)

  const setGoogleAuthLoading = useCallback((loading: boolean) => {
    setIsGoogleAuthLoading(loading)
  }, [])

  const setAppleAuthLoading = useCallback((loading: boolean) => {
    setIsAppleAuthLoading(loading)
  }, [])

  const setOutlookAuthLoading = useCallback((loading: boolean) => {
    setIsOutlookAuthLoading(loading)
  }, [])

  const isAnyAuthLoading =
    isGoogleAuthLoading || isAppleAuthLoading || isOutlookAuthLoading

  return (
    <CalendarAuthContext.Provider
      value={{
        isGoogleAuthLoading,
        isAppleAuthLoading,
        isOutlookAuthLoading,
        setGoogleAuthLoading,
        setAppleAuthLoading,
        setOutlookAuthLoading,
        isAnyAuthLoading,
      }}
    >
      {children}
    </CalendarAuthContext.Provider>
  )
}

export function useCalendarAuth() {
  const context = useContext(CalendarAuthContext)
  if (context === undefined) {
    throw new Error(
      'useCalendarAuth must be used within a CalendarAuthProvider'
    )
  }
  return context
}